import {Conversation} from '@stripe-internal/conversations-client';
import {RequestACallTopBar, useTheme} from '@stripe-internal/conversations-ui';
import {useEffect, useMemo} from 'react';
import {renderRequestACallError} from '../../components/Forms/RequestACall/renderRequestACallError';
import {useRequestACallDetails} from './useRequestACallDetails';

type Props = {
  conversation?: Conversation;
};

export const RACTopBar = ({conversation}: Props) => {
  const theme = useTheme();
  const {
    userName,
    userPhoneNumber,
    error,
    loading,
    verificationCodes,
    racStatus,
    isCancelLoading,
    cancelRac,
    callEnded,
  } = useRequestACallDetails({
    conversation,
  });

  const errorMesage = useMemo(
    () =>
      renderRequestACallError({
        theme,
        serverError: error,
      }),
    [theme, error],
  );

  useEffect(() => {
    if (callEnded && conversation) {
      conversation.leave();
    }
  }, [conversation, callEnded]);

  return (
    <RequestACallTopBar
      userName={userName}
      userPhoneNumber={userPhoneNumber}
      userCode={verificationCodes?.userCode || ''}
      agentCode={verificationCodes?.agentCode || ''}
      error={errorMesage}
      loading={loading}
      racStatus={racStatus}
      isCancelLoading={isCancelLoading}
      onCancel={() => cancelRac()}
    />
  );
};
